import mainServer from '@/api/index'

const state = {
    sheets: [
        // {
        //     id: 78974562341233,
        //     index: 0,
        //     orderNumber: "SDTUS2108140006",
        //     sheetNo: "WSN20210913",
        //     createDate: "2021-08-14",
        //     createBy: "文静",
        //     currentStatus: "处理中",
        //     description: "UPS末端签收少件",
        //     sheetType: "2", // 1 信息不全 2 状态异常，
        //     comments: [
        //         {
        //             id: 978974562341233,
        //             parentId: 0,
        //             createBy: "Alice",
        //             createDate: "2021-09-03",
        //             description: "1Z849AA20391159115,2件只收到一件",
        //             comments:[]
        //         },
        //         {
        //             id: 978974562341234,
        //             parentId: 0,
        //             createBy: "文静",
        //             createDate: "2021-09-03",
        //             description: "调取相关UPS 签收单证",
        //             comments:[]
        //         }
        //     ]
        // },
        // {
        //     id: 78974562341234,
        //     index: 1,
        //     orderNumber: "SDTUS2108140012",
        //     sheetNo: "WSN20210914",
        //     createDate: "2021-08-14",
        //     createBy: "孙玉刚",
        //     currentStatus: "处理中",
        //     description: "UPS提取未签收",
        //     sheetType: "2", // 1 信息不全 2 状态异常，
        //     comments: [
        //         {
        //             id: 978974562351233,
        //             parentId: 0,
        //             createBy: "Alice",
        //             createDate: "2021-09-05",
        //             description: "1Z849AA20392309497,提取了7天还没有签收",
        //             comments:[]
        //         },
        //         {
        //             id: 978974562351234,
        //             parentId: 0,
        //             createBy: "孙玉刚",
        //             createDate: "2021-09-05",
        //             description: "已通知UPS发起调查，超过15日未签收，开启索赔流程",
        //             comments:[]
        //         }
        //     ]
        // }
    ],

};

const mutations = {

    setSheets(state, data) {
        state.sheets = data;
    },

    setSheet(state, data) {
        let sheets = [...state.sheets]
        sheets[data.index].comments.push(data.info)
        state.sheets = sheets
    }

};

const actions = {



};

export default {
    state,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./src/store/dashboard.js